module.exports = __webpack_public_path__ + "static/media/plus.5413b196.svg";